export const postConstants = {
  GETALL_REQUEST: 'POST_GETALL_REQUEST',
  GETALL_SUCCESS: 'POST_GETALL_SUCCESS',
  GETALL_FAILURE: 'POST_GETALL_FAILURE',

  GET_REQUEST: 'POST_GET_REQUEST',
  GET_SUCCESS: 'POST_GET_SUCCESS',
  GET_FAILURE: 'POST_GET_FAILURE',

  ADD_REQUEST: 'POST_ADD_REQUEST',
  ADD_SUCCESS: 'POST_ADD_SUCCESS',
  ADD_FAILURE: 'POST_ADD_FAILURE',

  UPDATE_REQUEST: 'POST_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'POST_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'POST_UPDATE_FAILURE',
}